export default "__VITE_ASSET__f8541479__"